import { AssetShareOwnershipType } from '/@/modules/asset/enums/AssetShareOwnershipType';

export class AssetOwnershipMeta {
  /**
   * @var {string}
   */
  shareOwnershipType;

  constructor(model = {}) {
    this.shareOwnershipType = model.shareOwnershipType;
  }

  /**
   * @var {boolean}
   */
  get isSoleOwnership() {
    return this.shareOwnershipType === AssetShareOwnershipType.SOLE.key;
  }

  /**
   * @var {boolean}
   */
  get isJointOwnership() {
    return this.shareOwnershipType === AssetShareOwnershipType.JOINT.key;
  }

  /**
   * @var {boolean}
   */
  get isJointSurvivorshipOwnership() {
    return this.shareOwnershipType === AssetShareOwnershipType.JOINT_WITH_SURVIVORSHIP_RIGHT.key;
  }
}
